export default __webpack_public_path__ + "static/media/plan-table-green-cir.34b81640.svg";